"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createTrackerRegistry = exports.TrackerRegistry = void 0;
const utils_1 = require("@streamr/utils");
class TrackerRegistry {
    constructor(records) {
        this.records = records.slice(); // copy before mutating
    }
    getTracker(streamPartId) {
        const index = (0, utils_1.keyToArrayIndex)(this.records.length, streamPartId);
        return this.records[index];
    }
    getAllTrackers() {
        return this.records;
    }
}
exports.TrackerRegistry = TrackerRegistry;
function createTrackerRegistry(servers) {
    return new TrackerRegistry(servers);
}
exports.createTrackerRegistry = createTrackerRegistry;
//# sourceMappingURL=TrackerRegistry.js.map